module.exports = __webpack_public_path__ + "img/logo.d05cf80c.svg";